import React from 'react';
import { useTimeline } from './TimelineProvider';
import { getScaledLabel, getScaleTimeIncrement } from './utils';
import { TimelineTickGroup } from './TimelineRulerTickGroup';
import {
  TimelineTrack,
  TimelineTrackLabel,
  TimelineTrackSlot,
} from './TimelineTrack';
import { TimelineScaleSlider } from './TimelineScaleSlider';

/**
 * This is the ruler to place across the top of the timeline to give the user a sense of scale
 * and where the current "playhead" rests in that scale.
 */
export function TimelineRuler(): React.ReactElement {
  const { scale, startTime, timelineUnitCount } = useTimeline();

  return (
    <div className="odin-relative odin-border-b odin-border-b-1 odin-border-b-slate-300 odin-h-[20px]">
      {Array.from({ length: timelineUnitCount }, (_, i) => {
        const increment = getScaleTimeIncrement(scale, 1);
        const currentTimeIncrement = increment * i;
        const start = startTime + currentTimeIncrement;
        const label = getScaledLabel(start, scale);
        return (
          <TimelineTickGroup
            key={`timeline-tick-group-${start}`}
            label={label}
            position={i / timelineUnitCount}
            scaledSize={1 / timelineUnitCount}
            start={start}
          />
        );
      })}
    </div>
  );
}

/** This is a ready-made track for the complete ruler but the ruler can be assembled compositionally as well */
export function TimelineRulerTrack(props: {
  hideScaleSlider?: boolean;
}): React.ReactElement {
  const { hideScaleSlider } = props;
  return (
    <TimelineTrack>
      <TimelineTrackLabel>
        {!hideScaleSlider && <TimelineScaleSlider />}
      </TimelineTrackLabel>
      <TimelineTrackSlot color={null}>
        <TimelineRuler />
      </TimelineTrackSlot>
    </TimelineTrack>
  );
}
